import {
  FETCH_CONTACT_BY_ID,
  FETCH_CONTACT_BY_ID_SUCCEDDED,
  FETCH_CONTACT_BY_ID_FAILED,
  FETCH_HUBSPOT_RECOMMENDED_ASSETS,
  FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED,
  FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED,
  FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY,
  FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED,
  FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED,
  INVALIDATE_HUBSPOT_CONTACT,
  INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS,
  INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY
} from "../../actions/actionTypes";
import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import buildUrl from 'build-url-ts';
import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import { fetchContactByEmail } from "src/legacy/redux/actions/rolodex";
import { FetchContactByIdErrorResponse, FetchContactByIdRequest, FetchContactByIdResponse, FetchHubspotRecommendedAssetRequest, FetchHubspotRecommendedAssetsErrorResponse, FetchHubspotRecommendedAssetsResponse, FetchHubspotSharesForOpportunityErrorResponse, FetchHubspotSharesForOpportunityRequest, FetchHubspotSharesForOpportunityResponse } from "src/types/settings/integrations/hubspot";

export const fetchContactById = createAction<FetchContactByIdRequest>(FETCH_CONTACT_BY_ID);
const fetchingContactByIdSucceeded = createAction<FetchContactByIdResponse>(FETCH_CONTACT_BY_ID_SUCCEDDED);
const fetchingContactByIdFailed = createAction<FetchContactByIdErrorResponse>(FETCH_CONTACT_BY_ID_FAILED);

const apiUrl = process.env.REACT_APP_API_URL;
const API_BASE_URL = `${apiUrl}/api/2.0/integrations/hubspot`;

export const fetchContactByIdSaga = function* (action: ReturnType<typeof fetchContactById>): any {
  const contactId = action.payload;
  const url = buildUrl(`${API_BASE_URL}/contact/${contactId}`);

  const fetchContactByIdAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchContactByIdAPI);
    yield put(fetchingContactByIdSucceeded(response));
    yield put(fetchContactByEmail(response.email));
  } catch (error) {
    yield put(fetchingContactByIdFailed({ error }));
  } 
}

export const fetchHubspotRecommendedAssets = createAction<FetchHubspotRecommendedAssetRequest>(FETCH_HUBSPOT_RECOMMENDED_ASSETS);
const fetchingHubspotRecommendedAssetsSucceeded = createAction<FetchHubspotRecommendedAssetsResponse>(FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED);
const fetchingHubspotRecommendedAssetsFailed = createAction<FetchHubspotRecommendedAssetsErrorResponse>(FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED);

export const fetchHubspotRecommendedAssetsSaga = function* (action: ReturnType<typeof fetchHubspotRecommendedAssets>): any {
  const dealId = action.payload.dealId;
  const url = buildUrl(`${API_BASE_URL}/recommended-assets/${dealId}`);

  const fetchHubspotRecommendedAssetsAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchHubspotRecommendedAssetsAPI);
    yield put(fetchingHubspotRecommendedAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchingHubspotRecommendedAssetsFailed({ error }));
  } 
}

export const fetchHubspotSharesForOpportunity = createAction<FetchHubspotSharesForOpportunityRequest>(FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY);
const fetchingHubspotSharesForOpportunitySucceeded = createAction<FetchHubspotSharesForOpportunityResponse>(FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED);
const fetchingHubspotSharesForOpportunityFailed = createAction<FetchHubspotSharesForOpportunityErrorResponse>(FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED);

export const fetchHubspotSharesForOpportunitySaga = function* (action: ReturnType<typeof fetchHubspotSharesForOpportunity>): any {
  const opportunityId = action.payload;
  const url = buildUrl(`${API_BASE_URL}/opportunity-mappings/${opportunityId}`);
  const fetchHubspotSharesForOpportunityAPI = () => { 
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchHubspotSharesForOpportunityAPI);
    yield put(fetchingHubspotSharesForOpportunitySucceeded(response));
  } catch (error) {
    yield put(fetchingHubspotSharesForOpportunityFailed({ error }));
  } 
}

export const invalidateHubspotContact = createAction(INVALIDATE_HUBSPOT_CONTACT);
export const invalidateHubspotRecommendedAssets = createAction(INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS);
export const invalidateHubspotSharesForOpportunity = createAction(INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY);


export default function* hubspotIntegrationSaga() {
  yield takeEvery(FETCH_CONTACT_BY_ID, fetchContactByIdSaga);
  yield takeLatest(FETCH_HUBSPOT_RECOMMENDED_ASSETS, fetchHubspotRecommendedAssetsSaga);
  yield takeLatest(FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY, fetchHubspotSharesForOpportunitySaga);
}